"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignaturePadSink = void 0;
const signature_pad_1 = require("client/components/ui/signature-pad");
const react_1 = require("react");
const React = require("react");
const socketIo = require("socket.io-client");
const SERVER_URL = `${window.location.protocol}//${window.location.host}`;
class SignaturePadSink extends react_1.Component {
    componentDidMount() {
        this.socket = socketIo(SERVER_URL);
        this.socket.on("connect", () => {
            this.startHeartbeat();
            const jwt = localStorage.getItem("jwt");
            if (jwt) {
                this.socket.emit("auth", { jwt });
            }
            else {
                this.socket.emit("auth");
            }
        });
        this.socket.on("jwt", (data) => {
            if (data && data.jwt) {
                localStorage.setItem("jwt", data.jwt);
                this.socket.emit("auth", { jwt: data.jwt });
            }
            else {
                localStorage.removeItem("jwt");
                this.socket.emit("auth");
            }
        });
    }
    componentWillUnmount() {
        this.endHeartbeat();
        if (this.socket) {
            this.socket.disconnect();
        }
    }
    startHeartbeat() {
        this.heartbeatInterval = window.setInterval(() => {
            this.socket.emit("heartbeat");
        }, 60 * 1000);
    }
    endHeartbeat() {
        window.clearInterval(this.heartbeatInterval);
    }
    render() {
        return (React.createElement("div", { className: "input-components" },
            React.createElement("h2", null, "Signature Pad"),
            React.createElement(signature_pad_1.SignatureComponent, null)));
    }
}
exports.SignaturePadSink = SignaturePadSink;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/signature-pad/signature-pad.tsx
// module id = 3675
// module chunks = 0